import { Controller } from "@hotwired/stimulus"

// Optional progressive enhancement. The server-owned request context remains
// authoritative and the form is fully usable when JavaScript is unavailable.
export default class extends Controller {
  static targets = ["viewport", "platform", "locale", "timezone"]

  connect() {
    this.viewportTarget.value = `${window.innerWidth}x${window.innerHeight}`
    this.platformTarget.value = navigator.userAgentData?.platform || navigator.platform || ""
    this.localeTarget.value = navigator.language || ""
    this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone || ""
  }
}
